import { render, staticRenderFns } from "./AdminCalendarsDialog.vue?vue&type=template&id=0f105250&scoped=true"
import script from "./AdminCalendarsDialog.vue?vue&type=script&lang=js"
export * from "./AdminCalendarsDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminCalendarsDialog.vue?vue&type=style&index=0&id=0f105250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f105250",
  null
  
)

export default component.exports